import { Outlet } from "react-router-dom";
import { useLoadingSplashOverlay } from "@songtradr/design-language";
import { useBfCacheRestore } from "../shared/hooks/use-bf-cache-restore";
import { AuthContext, useLoaderData } from "./App.Parts";

export const App = () => {
  const { removeLoadingSplash } = useLoadingSplashOverlay();
  useBfCacheRestore(removeLoadingSplash); // Remove loading splash when page is loaded from bfcache...

  const { getAuthContext } = useLoaderData();

  return (
    <AuthContext.Provider value={getAuthContext}>
      <Outlet />
    </AuthContext.Provider>
  );
};
